import { getCookie, setCookie } from '@lhb/cache';

// 接入大数据埋点
// 文档：https://docs.lanhanba.net/fe/@lhb%2Flhb-bigdata?name=docs
// 开发环境屏蔽
if (process.env.NODE_ENV !== 'development') {
  if (!getCookie('kunlun_user_id') && !getCookie('kunlun_token')) { // 如果未登录，随机记录一个用户id（场地清单-游客访问，记录埋点功能）
    setCookie('kunlun_user_id', +new Date() + (1000 + Math.random() * 10000).toFixed(0));
  }
  if (!getCookie('tenant_id')) {
    setCookie('tenant_id', process.env.LHB_TENANT_ID);
  }
  window.LHBbigdata.init({
    isSpa: true,
    si: 'pc',
    cha_type: 'LCN',
    // 将从 cookie/localStorage 中获取
    extendOuterConfig: [
      { key: 'user_id', target: 'kunlun_user_id' },
      { key: 'token', target: 'kunlun_token' },
      { key: 'tenant_id', target: 'tenant_id' }, // 租户id
    ], // 默认抓取localStorage里的参数(外层参数)
    sendFunc: function(params, config) {
      try {
        window.LHBbigdata.xhrTool.send(`${config[process.env.NODE_TYPE === 'pe' ? 'logPathPro' : 'logPathPre']}`, params);
      } catch (err) {
        console.log(err);
      }
    },
  });
}
